export const containerClasses =
  'relative block after:content-[""] after:absolute after:top-0 after:right-0 after:w-5 after:h-full after:bg-transparent after:border-r-4 after:skew-x-[-35deg] after:origin-top-right';

export const contentClasses = 'flex flex-row items-center gap-0.5 bg-gray-0 pl-2 py-1 pr-[22px] sm:pl-3 sm:pr-7 sm:py-2 text-xs body-xs-medium';

export const clippedWrapperClasses =
  'relative [clip-path:polygon(0_0,100%_0,calc(100%-18px)_100%,0_100%)] sm:[clip-path:polygon(0_0,100%_0,calc(100%-25px)_100%,0_100%)]';

export const tooltipClasses = 'p-3 text-sm lumon:body-s shadow-lg rounded-lg bg-default-minimal not-lumon:text-base';
